import React, { lazy } from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function ContactSection() {
  const {
    t
  } = useLanguage();
  return <section id="contact" className="py-28 lg:py-36 px-6 bg-[#FAFAF8]" data-id="element-63">
      <div className="max-w-7xl mx-auto" data-id="element-64">
        <div className="text-center mb-16" data-id="element-65">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mb-3 font-light" data-id="element-66">
            {t('contact.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20" data-id="element-67">
          {/* Contact Info */}
          <div className="space-y-12" data-id="element-68">
            <div className="flex items-start space-x-6" data-id="element-69">
              <MapPin className="w-5 h-5 mt-1 text-[#D4AF37]" strokeWidth={1.5} data-id="element-70" />
              <div data-id="element-71">
                <h3 className="text-[10px] tracking-[0.3em] uppercase mb-3 text-gray-500 font-light" data-id="element-72">
                  {t('contact.address.title')}
                </h3>
                <p className="font-light text-base mb-1" data-id="element-73">
                  {t('contact.address.full')}
                </p>
                <p className="font-light text-gray-600 text-sm" data-id="element-74">
                  {t('contact.address.city')}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-6" data-id="element-75">
              <Clock className="w-5 h-5 mt-1 text-[#D4AF37]" strokeWidth={1.5} data-id="element-76" />
              <div data-id="element-77">
                <h3 className="text-[10px] tracking-[0.3em] uppercase mb-3 text-gray-500 font-light" data-id="element-78">
                  {t('contact.schedule.title')}
                </h3>
                <p className="font-light text-base mb-2" data-id="element-79">
                  {t('contact.schedule.weekdays')}
                </p>
                <p className="font-light text-base mb-2" data-id="element-80">
                  {t('contact.schedule.saturday')}
                </p>
                <p className="font-light text-base text-gray-500" data-id="element-81">
                  {t('contact.schedule.sunday')}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-6" data-id="element-82">
              <Phone className="w-5 h-5 mt-1 text-[#D4AF37]" strokeWidth={1.5} data-id="element-83" />
              <div data-id="element-84">
                <h3 className="text-[10px] tracking-[0.3em] uppercase mb-3 text-gray-500 font-light" data-id="element-85">
                  {t('contact.phone.title')}
                </h3>
                <p className="font-light text-base" data-id="element-86">
                  {t('contact.phone.number')}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-6" data-id="element-87">
              <Mail className="w-5 h-5 mt-1 text-[#D4AF37]" strokeWidth={1.5} data-id="element-88" />
              <div data-id="element-89">
                <h3 className="text-[10px] tracking-[0.3em] uppercase mb-3 text-gray-500 font-light" data-id="element-90">
                  {t('contact.email.title')}
                </h3>
                <p className="font-light text-base" data-id="element-91">hello@na5poverhiv.com</p>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="aspect-[4/3] bg-gray-200 overflow-hidden border border-[#D4AF37]/10" data-id="element-92">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2629.8!2d28.4682!3d49.2328!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x472d5b6e1e1e1e1e%3A0x1e1e1e1e1e1e1e1e!2z0LLRg9C70LjRhtGPIDYwMC3RgNGW0YfRh9GPLCAXNQ!5e0!3m2!1suk!2sua!4v1234567890" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="На 5 поверхів location" data-id="element-93"></iframe>
          </div>
        </div>
      </div>
    </section>;
}